export class UnitMeasure {
    constructor(
        public id: number,
        public measure: number,
        public totalMeasure: number,
        public unitName: string,
        public longUnitName: string,
        public measureName: string,
        public isDefault: number
    ) { }
}